import React, { useCallback, useEffect, useState } from "react";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "react-perfect-scrollbar/dist/css/styles.css";
import {
  Menu,
  MenuItem,
  ProSidebar,
  SidebarContent,
  SidebarHeader,
} from "react-pro-sidebar";
import { Link, useLocation } from "react-router-dom";
import useWindowDimensions from "../header/Dimensions";
import { useDispatch, useSelector } from "react-redux";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { setState } from "../../redux/dataSlice";

const LiveSideBar = React.memo((props) => {
  const { spid } = props;

  const location = useLocation();
  const { width } = useWindowDimensions();
  const liveCount = useSelector((state) => state.matchesData.sport_live_count);
  const dispatchRedux = useDispatch();
  const active_link = useSelector((state) => state.data.active_live_link);
  const getSportImageIcon = (
    sport_name,
    folder = "sports",
    topLeagues = false,
    flag = false
  ) => {
    if (flag) {
      let splitString = sport_name.split(" ");
      sport_name = splitString[0].substr(0, 2).toString().toLowerCase();
    }

    let default_img = "default_sport";
    let sport_image;
    try {
      sport_image = topLeagues
        ? require(`../../assets/img/${folder}/${sport_name}.svg`)
        : require(`../../assets/svg/${folder}/${sport_name}.svg`);
    } catch (error) {
      sport_image = require(`../../assets/img/${default_img}.svg`);
    }
    return sport_image;
  };

  const [liveSports, setLiveSports] = useState();
  useEffect(() => {
    setLiveSports(liveCount);
  }, [liveCount]);

  const setActiveLink = useCallback(
    (link) => {
      dispatchRedux(setState("active_live_link", link));
    },
    [dispatchRedux]
  );

  useEffect(() => {
    const path = location.pathname;
    if (path === "/live") {
      setActiveLink(79);
    } else if (path.startsWith("/live/") && spid) {
      setActiveLink(spid);
    }
    // setActiveLink(spid||79)
  }, [spid, location.pathname, setActiveLink]);

  return (
    <div className={`${width <= 991 ? "" : "d-md-block  h-100"}`}>
      <div
        style={{
          display: "flex",
          overflow: "scroll initial",
          zIndex: 10,
          marginRight: "2px",
          // marginTop: "10px"
        }}
        className={`${width <= 991 ? "" : "vh-100  sticky-top  d-md-block up"}`}
      >
        <ProSidebar
          className={`${width <= 991 ? "w-100" : "live-pro-sidebar"}`}
          style={{ backgroundColor: "#16202c !important" }}
          image={false}
        >
        
       
          <SidebarContent className={"sidebar-live "}>
            <Menu iconShape="circle live-inner">
              {liveSports &&
                Object.entries(liveSports).map(
                  ([index, livesport], live_index) => (
                    <Menu
                      iconShape="circle inner-live live-items"
                      key={live_index}
                    >
                      <MenuItem className={`live-items `}>
                        <Link
                          className={`col-12  ${
                            Number(active_link) === livesport.sport_id
                              ? "active_link"
                              : "link-inactive"
                          }`}
                          to={`/live/${livesport.sport_id}`}
                        >
                          <Row>
                            <Col className="topl">
                              {width > 991 ? (
                                <Row
                                  className={"gap-2"}
                                  style={{ color: "#69819a" }}
                                >
                                  <div
                                    className={` d-flex align-items-center align-self-center live_sidebar ${
                                      Number(active_link) === livesport.sport_id
                                        ? "active_link"
                                        : "link-inactive"
                                    }`}
                                  >
                                    <LazyLoadImage
                                      style={{
                                        borderRadius: "50%",
                                        height: "15px",
                                      }}
                                      src={getSportImageIcon(
                                        livesport?.sport_name
                                      )}
                                    />
                                    &nbsp;
                                    <span>{livesport?.sport_name}</span>&nbsp;
                                    <span
                                      className={`badge  live-slide  live-side-badge d-flex align-items-center`}
                                    >
                                      {livesport?.count}
                                    </span>
                                  </div>
                                </Row>
                              ) : (
                                <Row style={{ color: "#69819a" }} className="px-4 live-item">
                                  <div
                                    className={` d-flex align-items-center align-self-center live_sidebar  flex-column ${
                                      Number(active_link) === livesport.sport_id
                                        ? "active_link"
                                        : "link-inactive"
                                    }`}
                                  >
                                    <div style={{ position: "relative" }}>
                                      <LazyLoadImage
                                        style={{
                                          borderRadius: "50%",
                                          height: "23px",
                                        }}
                                        src={getSportImageIcon(
                                          livesport?.sport_name
                                        )}
                                      />
                                      <span
                                        className={`badge  live-slide  live-side-badge d-flex align-items-center`}
                                      >
                                        {livesport?.count}
                                      </span>
                                    </div>

                                    <span>{livesport?.sport_name}</span>
                                  </div>
                                </Row>
                              )}
                            </Col>
                          </Row>
                        </Link>
                      </MenuItem>
                    </Menu>
                  )
                )}
            </Menu>
          </SidebarContent>
        </ProSidebar>
      </div>
    </div>
  );
});
export default React.memo(LiveSideBar);
